import * as React from 'react';

export const CrownSvg = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="35" height="31" viewBox="0 0 35 31"><path d="M8647.969,13902.955h-11.115l-.549-4.354h23.332l-.555,4.354Zm-11.928-6.527-1.777-13.985,7.25,5.216,6.455-8.682,6.457,8.682,7.244-5.216-1.775,13.985Zm24.889-17.911a2.02,2.02,0,1,1,2.018,2.081A2.054,2.054,0,0,1,8660.93,13878.517Zm-29.961,0a2.02,2.02,0,1,1,2.02,2.081A2.052,2.052,0,0,1,8630.969,13878.517Zm14.979-3.48a2.021,2.021,0,1,1,2.021,2.075A2.054,2.054,0,0,1,8645.947,13875.036Z" transform="translate(-8630.469 -13872.455)" fill="#ffd803" stroke="rgba(0,0,0,0)" strokeWidth="1"/></svg>
  );
};
